<template>
<span>
    <span v-if="!noLabel"> <b>Country</b><br/></span>
    <v-autocomplete :attach="attach"
        class="mr-2 pt-1" 
        outline 
        type="text" 
       
        hide-details 
        data-vv-name="country_id" 
        item-text="name" 
        item-value="id" 
        :items="countries" 
        @input= "countrySelected"
        :placeholder="noLabel ? 'Country' :''"
        :error-messages="errors.collect('country_id')" 
        v-model="country"
    /> 
</span>
</template>
<script>
import Country from '@/api/service/Countries.json';
export default {
    props:[
        "country","noLabel","attach"
    ],
    data() {
        return {
            "countries":Country
        }
    },
    methods: {
        countrySelected($id) {
            this.$emit("countrySelected",$id)
        }
    }
}
</script>